const HINT_VISIBLE_MS = 1400;

class ProductGalleryArrowHints {
  constructor(gallery) {
    this.gallery = gallery;
    this.hideTimeout = null;

    gallery.addEventListener('slideshow:select', (event) => {
      this.handle(event.detail.index);
    });

    this.handle(0);
  }

  handle(index) {
    const previous = this.gallery.querySelector('.product-gallery-mobile-arrows .slideshow-control--previous');
    const next = this.gallery.querySelector('.product-gallery-mobile-arrows .slideshow-control--next');
    const slideshow = this.gallery.querySelector('slideshow-component');
    if (!previous || !next || !slideshow) return;

    const lastIndex = slideshow.slides.length - 1;

    clearTimeout(this.hideTimeout);
    previous.classList.remove('gallery-hint-visible');
    next.classList.remove('gallery-hint-visible');

    let target = null;
    if (index === 0) target = next;
    else if (index === lastIndex) target = previous;

    if (!target) return;

    requestAnimationFrame(() => {
      target.classList.add('gallery-hint-visible');
      this.hideTimeout = setTimeout(() => {
        target.classList.remove('gallery-hint-visible');
      }, HINT_VISIBLE_MS);
    });
  }
}

document.querySelectorAll('.product-gallery-mobile-arrows').forEach((el) => {
  const gallery = el.closest('media-gallery');
  if (gallery && !gallery.dataset.arrowHintsWired) {
    gallery.dataset.arrowHintsWired = 'true';
    new ProductGalleryArrowHints(gallery);
  }
});
